/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import type { FloraOutput } from '$lib/apis/webchat/type';
import { get, writable } from 'svelte/store';
import { chatSession, notificationSoundEnabled } from './chatSessionStore';
import { soundNotification } from '$lib/utilities/soundNotification';
import { datadogLogs } from '@datadog/browser-logs';

const ding = '/chat/ding.mp3';

export const socketState = writable<{
    socket: WebSocket | null;
    status: string;
    messages: {
        sender: string;
        message: string;
        type: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params?: Record<string, any>;
    }[];
}>({
    socket: null,
    status: 'disconnected',
    messages: [] as {
        sender: string;
        message: string;
        type: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        params?: Record<string, any>;
    }[]
});

let socket: WebSocket | null = null;

export function connect(url: string, conversation_id: string, brand: string) {
    if (socket) {
        return;
    }

    socket = new WebSocket(url);
    socketState.update(state => ({ ...state, status: 'connecting' }));

    socket.onopen = () => {
        socketState.update(state => ({ ...state, status: 'connected', socket }));
    };

    socket.onmessage = (event) => {
        const message = JSON.parse(event.data);
        let surveyLink: string = ''
        socketState.update(state => ({
            ...state,
            messages: [...state.messages, message]
        }));
        if (typeof message.o === 'string' && message.o.includes('{')) {
            const parseSurvey = JSON.parse(message.o)
            surveyLink = parseSurvey?.richLinkData.url
        }
        if (message.o) {
            chatSession.update((old) => {
                const updatedSession = {
                    ...old,
                    messages: [
                        ...old.messages,
                        {
                            sender: 'agent',
                            message: surveyLink ? 'Have a nice day' : message.o,
                            type: 'text',
                            params: { survey_link: surveyLink ? surveyLink : '' } as FloraOutput['params']
                        }
                    ],
                };
                sessionStorage.setItem('conversation', JSON.stringify(updatedSession));
                return updatedSession;
            });
            datadogLogs.logger.info(`[Conv-ui] Dynamics Agent Message - conversation_id: ${conversation_id} brand:${brand} message: ${message.o}`)
            if (get(notificationSoundEnabled)) {
                const { play } = soundNotification(ding);
                play()
            }
        }
    };

    socket.onerror = (error) => {
        console.error('WebSocket Error:', error);
        socketState.update(state => ({ ...state, status: 'error' }));
    };

    socket.onclose = () => {
        socketState.update(state => ({ ...state, status: 'disconnected', socket: null }));
        socket = null;
    };
    return socket
}

export function socketDisconnect() {
    if (socket) {
        socket.close();
        socket = null;
        socketState.update(state => ({ ...state, status: 'disconnected', socket: null }));
    }
}

export function sendDynamicsMessage(message: string, conversation_id: string, brand: string) {
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ o: message, source: 'customer' }));
        datadogLogs.logger.info(`[Conv-ui] Dynamics Customer Message - conversation_id: ${conversation_id} brand:${brand} message: ${message}`)
    } else {
        console.warn('WebSocket is not connected.');
    }
}